import {
  BadgeDollarSign,
  BellRing,
  BellElectric,
  FileClock,
  FileText,
  Gavel,
  Landmark,
  Route,
  Scale,
  ShieldAlert,
  Tag,
  type LucideIcon,
} from 'lucide-react'

// O preço da consulta completa vem do backend: use o hook `usePricing` (features/pricing).

export function formatBRL(value: number) {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

/**
 * Indicadores entregues pelo relatório pago (módulo `vehicle` da Fonte Data, campo `checks`).
 * Mantenha esta lista alinhada ao backend: só prometa o que o relatório realmente traz.
 */
export const securityChecks: { label: string; icon: LucideIcon }[] = [
  { label: 'Passagem por leilão', icon: Gavel },
  { label: 'Roubo ou furto', icon: ShieldAlert },
  { label: 'Restrição judicial', icon: Scale },
  { label: 'Recall', icon: BellRing },
  { label: 'Pendência documental', icon: FileClock },
  { label: 'Comunicado de venda', icon: Tag },
  { label: 'Alarme registrado', icon: BellElectric },
  { label: 'Indicador de infrações', icon: Route },
]

/** Resumo do que o relatório completo entrega, usado nas ofertas. */
export const completeConsultationBenefits: { label: string; icon: LucideIcon }[] = [
  { label: `${securityChecks.length} verificações de segurança`, icon: ShieldAlert },
  { label: 'Passagem por leilão', icon: Gavel },
  { label: 'Restrição judicial', icon: Scale },
  { label: 'Valor FIPE para negociar', icon: BadgeDollarSign },
  { label: 'Documentação e dados técnicos', icon: FileText },
  { label: 'Infrações registradas na PRF', icon: Route },
  { label: 'Gravame (financiamento ativo)', icon: Landmark },
]

export type PlanItem = { label: string; included: boolean }

export const basicPlanItems: PlanItem[] = [
  { label: 'Marca, modelo e ano', included: true },
  { label: 'Cor, combustível e município', included: true },
  { label: 'Final do chassi', included: true },
  { label: 'Passagem por leilão e roubo/furto', included: false },
  { label: 'Restrição judicial e recall', included: false },
  { label: 'Valor FIPE', included: false },
  { label: 'Documentação e infrações na PRF', included: false },
  { label: 'Gravame (financiamento)', included: false },
]

export const completePlanItems: PlanItem[] = [
  { label: 'Tudo da consulta básica', included: true },
  { label: 'Passagem por leilão e roubo/furto', included: true },
  { label: 'Restrição judicial e recall', included: true },
  { label: `Mais ${securityChecks.length - 4} verificações de segurança`, included: true },
  { label: 'Valor FIPE para negociar', included: true },
  { label: 'Documentação e infrações na PRF', included: true },
  { label: 'Gravame (financiamento)', included: true },
  { label: 'Protocolo para acessar depois', included: true },
]
